import {
  objectiveHealthByIdsResponseSchema,
  objectiveHealthResponseSchema,
} from '@tempo-io/reporting-store-dto';
import { tempoApi } from '@/common/api/tempoApi';
import { REPORTING_STORE_API_BASE } from './constants';

const getByIds = async (objectiveIds: number[]) => {
  const response = await tempoApi()
    .post(`${REPORTING_STORE_API_BASE}/health/objectives/by-ids`, {
      json: objectiveIds,
    })
    .json();
  return objectiveHealthByIdsResponseSchema.parse(response);
};

const getById = async (objectiveId: number, params: { loopId?: number } = {}) => {
  const response = await tempoApi()
    .get(`${REPORTING_STORE_API_BASE}/health/objectives/${objectiveId}`, {
      searchParams: params.loopId !== undefined ? { loopId: params.loopId } : {},
    })
    .json();
  return objectiveHealthResponseSchema.parse(response);
};

export const ObjectiveHealthApi = { getByIds, getById };
